import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { numberWithCommas } from '../../../../utils/consts';
import momentjs from 'moment-jalaali';
import {
  returnFormatTime,
  returnAirlineLogos,
} from '../../../../utils/utility/booking';
import '../mobileFlightDetails/mobileFlightDetails.scss';
import { DepartureAirplaneIcon, ArrivalAirplaneIcon, CoinIcon } from '~svg';
import { getExpirationStatus } from '../../../../utils/consts/reservedExpiration';
import moment from 'moment';

class MobileFlightInfoBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectUnpaidFlightList: [],
    };
  }

  // this function for select ticketUnpaid onchange

  selectUnpaidFlight = (event) => {
    let { selectUnpaidFlightList } = this.state,
      { id } = event.target;

    if (selectUnpaidFlightList.findIndex((flight) => flight === id) === -1)
      selectUnpaidFlightList.push(id);
    else
      selectUnpaidFlightList = selectUnpaidFlightList.filter(
        (item) => item !== id,
      );
    this.setState({ selectUnpaidFlightList }, () => {
      this.props.returnSelectedUnpaidFlightList(id);
    });
  };

  // this function for render airline logos

  // this function for render airline icon

  renderAirplaneIcon(flight) {
    let { name, direction } = this.props.language;
    let allAirlines = [
      ...new Set(flight.map((t) => [t.operatingAirline])),
    ].reduce((a, b) => {
      return a.concat(b);
    });
    let operatingAirlines = [
      ...new Map(allAirlines.map((item) => [item.code, item])).values(),
    ];
    if (flight?.length && operatingAirlines?.length) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-start">
          <div className="d-flex border p-1 flex-row align-items-center justify-content-center rounded-circle position-relative ">
            {operatingAirlines.map((item, index) => {
              let position = -30 * index;
              return (
                <img
                  key={`img-${index}`}
                  alt="logo"
                  style={{
                    width: 30,
                    hight: 30,
                    // zIndex: operatingAirlines.length - index,
                    zIndex: 0,
                    marginRight:
                      direction === 'ltr'
                        ? operatingAirlines?.length === 1 || index === 0
                          ? '0px'
                          : `${position}px`
                        : '0px',
                    marginLeft:
                      direction === 'rtl'
                        ? operatingAirlines?.length === 1 || index === 0
                          ? '0px'
                          : `${position}px`
                        : '0px',
                  }}
                  title={item.name[name]}
                  className={`d-flex justify-content-center rounded-circle bg-white border border-1 ${
                    index === 0 ? '' : 'position-absolute'
                  }
                   
                   `}
                  src={returnAirlineLogos(item?.code)}
                />
              );
            })}
          </div>

          {operatingAirlines?.length === 1 ? (
            <div className="d-flex pt-1 justify-content-center w-100 align-items-start font-smaller text-center text-third font-weight-bold text-nowrap">
              {operatingAirlines[0]?.name[name]}
            </div>
          ) : (
            <div className="d-flex justify-content-center  w-100 align-items-start font-xsmall text-center font-weight-bold position-relative">
              {this.props.intl.formatMessage({
                id: 'booking.multiairline',
              })}
            </div>
          )}
        </div>
      );
    }
  }
  render() {
    let {
        index,
        flightLength,
        item,
        totalPassenger,
        className = '',
        pageName = '',
        user,
      } = this.props,
      { name, direction } = this.props.language,
      itineraries = item.flights.itineraries;
    let ticketLimitTime = item.flights.ticketTimeLimit;
    const localticketLimitTime = moment.utc(ticketLimitTime).local();
    const expiryLimit = localticketLimitTime.format('YYYY-MM-DD HH:mm');
    let shamsiTicketLimitTime = '';
    let showProvider = false;
    let stakeholder = localStorage.getItem('stakeholder');
    let profile = localStorage.getItem('profile');
    if (user?.userInfo?.profiles) {
      let profiles = user?.userInfo?.profiles
        .map((t) => t.profile)
        .filter((t) => t.displayName.en === process.env.AGENCY_NAME);
      if (profiles.map((item) => item.id).includes(parseInt(stakeholder)))
        showProvider = true;
    }
    if (ticketLimitTime) {
      ticketLimitTime = momentjs(ticketLimitTime).format('YYYY-MM-DD HH:mm');
      shamsiTicketLimitTime =
        direction === 'rtl'
          ? momentjs(expiryLimit, 'YYYY-MM-DD HH:mm')
              .local('fa')
              .format('jYYYY-jMM-jDD HH:mm')
          : '';
    } else {
      ticketLimitTime = '--';
      shamsiTicketLimitTime = '--';
    }

    return (
      <div
        onClick={() => {
          this.props.flag !== 'unpaidreservation'
            ? this.props.returnShowDetailFlag(true, index)
            : null;
        }}
        key={`flightInfo-${index}`}
        className={`border border-2 text-dark p-0 font-weight-bold text-left card bg-white my-2 cursor-pointer default-border-radius-small mobile-rounded ${className} ${
          index === flightLength - 1 && pageName !== 'saleAccounting'
            ? 'mb-5'
            : 'mb-0'
        }`}
      >
        <div className=" w-100 d-flex flex-row justify-content-center  card-body p-0 pb-1">
          <div className={`d-flex p-0 flex-column w-100 position-relative `}>
            {itineraries.map((flight, indx) => {
              let flightObj = flight.flights,
                // stopCount = parseInt(flight.stopCount);
                departDate = flightObj[0].departureDateTime.split('T')[0],
                departDateArray = departDate.split('T')[0].split('-');

              return (
                <div
                  onClick={() => {
                    this.props.flag === 'unpaidreservation'
                      ? this.props.returnShowDetailFlag(true, index)
                      : null;
                  }}
                  key={`mainflight-${index}-${indx}`}
                  style={{
                    borderBottom:
                      indx !== itineraries.length - 1 ? 'dashed  1px' : '',
                    borderColor: itineraries.length - 1 ? 'silver' : '',
                  }}
                  className="d-flex w-100 py-1 px-2 m-0 flex-column "
                >
                  <div className="pt-2 px-2 d-flex flex-row justify-content-start w-100 align-items-start text-dark justify-content-start  font-smaller">
                    <div className="col-2 px-0">
                      {this.renderAirplaneIcon(flightObj)}
                    </div>
                    <div className="col-8 px-0 d-flex flex-column justify-content-center align-items-center">
                      <div className="d-flex flex-row justify-content-center align-items-center">
                        {/* <span className="font-smaller mobile-light-color"> */}
                        {/* <FormattedMessage id="booking.orderdate" /> */}
                        {/* <img
														src="/dist/assets/images/destination.png"
														style={{ width: "24px" }}
														alt="picture"
													/>
												</span> */}
                        <FormattedMessage id="booking.invoice" />
                        <span className="px-1">:</span>
                        <span className="font-msmall text-secondary text-nowrap">
                          {/* {`${returnFlightDate(
														item.orderDate,
														name,
														true
													)} - ${item.orderDate.split("T")[1].substring(0, 5)}`} */}
                          {direction === 'ltr'
                            ? item.orderDate.split('T')[0]
                            : momentjs(
                                item.orderDate.split('T')[0],
                                'YYYY-MM-DD',
                              )
                                .local('fa')
                                .format('jYYYY-jMM-jDD')}
                        </span>
                      </div>
                      <div className="d-flex flex-row justify-content-center align-items-center pt-1">
                        <div className="font-smaller d-flex flex-row justify-content-center align-items-center px-1 text-third text-nowrap">
                          <span>{itineraries[0].pnr}</span>
                        </div>
                        <div className="font-smaller d-flex flex-row justify-content-center align-items-center px-1 text-third text-nowrap">
                          (
                          <span className="px-1">
                            {itineraries[0].gateway.code}
                          </span>
                          )
                        </div>
                      </div>
                    </div>
                    <div className="col-2 px-0 text-third"></div>
                  </div>
                  <div className="d-flex">
                    {this.props.flag === 'reserve' ||
                    this.props.flag === 'expired' ? (
                      <div className="d-flex justify-content-start text-uppercase p-2 align-items-center font-msmall mobile-light-color">
                        {ticketLimitTime && (
                          <>
                            <span
                              className={`d-flex ${
                                getExpirationStatus(ticketLimitTime).className
                              }`}
                            >
                              <FormattedMessage
                                id={
                                  getExpirationStatus(ticketLimitTime).messageId
                                }
                              />
                            </span>
                            <span
                              className={`d-flex px-1 ${
                                getExpirationStatus(ticketLimitTime).isExpired
                                  ? 'text-danger'
                                  : getExpirationStatus(ticketLimitTime)
                                      .className
                              }`}
                              style={{ direction: 'ltr' }}
                            >
                              {direction === 'rtl'
                                ? shamsiTicketLimitTime
                                : expiryLimit}
                            </span>
                          </>
                        )}
                      </div>
                    ) : null}
                  </div>
                  <div className="font-smaller w-100 d-flex flex-row justify-content-center align-items-center text-third text-nowrap py-2">
                    <div className="col-3 d-flex flex-row justify-content-center align-items-center px-0 text-third">
                      <span className="font-smaller mobile-light-color px-0 d-flex flex-row justify-content-center">
                        {/* <FormattedMessage id="booking.orderdate" /> */}
                        {indx == 0 || item.itineraries > 2 ? (
                          <DepartureAirplaneIcon size={18} color={'#3d4a8f'} />
                        ) : (
                          <ArrivalAirplaneIcon size={18} color={'#3d4a8f'} />
                        )}
                      </span>
                    </div>
                    <span className="col-6 px-0 d-flex flex-row justify-content-center align-items-center">
                      {/* {`${returnFlightDate(
												item.orderDate,
												name,
												true
											)} - ${item.orderDate.split("T")[1].substring(0, 5)}`} */}
                      {direction === 'ltr'
                        ? item.orderDate.split('T')[0]
                        : momentjs(
                            item.orderDate.split('T')[0],
                            'YYYY-MM-DD HH:mm',
                          )
                            .local('fa')
                            .format('jYYYY-jMM-jDD HH:mm')}
                    </span>
                    <div className="col-3 px-0 text-third text-center text-truncate">
                      {direction === 'rtl'
                        ? flightObj[flightObj.length - 1].equipment.name.fa
                        : flightObj[flightObj.length - 1].equipment.name.en}
                    </div>
                  </div>
                  {/* top of center */}
                  {/* <div className="d-flex w-100 align-items-center justify-content-between pb-2 px-2"> */}
                  {/* <div className="d-flex justify-content-start align-items-center px-1 w-25 mobile-light-color">
                        <i
                          className="fal fa-plane-departure font-smaller d-flex mobile-light-color"
                          style={{
                            transform: `${
                              indx == 0 || flight.length > 2
                                ? ""
                                : " rotateY(180deg)"
                            }`,
                          }}
                        />
                        <span className="font-xsmall px-1">
                          <FormattedMessage
                            id={`${
                              indx == 0 || flight.length > 2
                                ? "booking.departure"
                                : "booking.return"
                            }`}
                          />
                        </span>
                      </div> */}
                  {/* <div className="d-flex justify-content-center align-items-center font-xsmall font-weight-bold text-dark w-50"> */}
                  {/* <FormattedMessage
                        id={`booking.${
                          stopCount === 0
                            ? "nonstop"
                            : stopCount === 1
                            ? "onestop"
                            : "morethanonestop"
                        }`}
                        defaultMessage="booking.nonstop"
                      /> */}
                  {/* {departDate ? returnMonthDay(departDate, name) : "--"}

                        {direction === "rtl" ? (
                          <div className="d-flex text-dark font-xsmall  align-items-center justify-content-center ">
                            {` - ${departDateArray[2]} ${
                              fullMonths["ltr"]["fa"][departDateArray[1] - 1]
                            } 
                          `}
                          </div>
                        ) : null}
                      </div> */}
                  {/* <div
                        className={`${
                          flightObj[0].equipment.hasOwnProperty("name") &&
                          flightObj[0].equipment.name[name].length < 30
                            ? " justify-content-center "
                            : "justify-content-start"
                        }  d-flex  text-truncate mobile-light-color font-xsmall w-25`}
                      >
                        {flightObj[0].equipment.hasOwnProperty("name")
                          ? flightObj[0].equipment.name[name]
                          : "--"}
                      </div> */}
                  {/* </div> */}
                  <div className="d-flex flex-row justify-content-center align-items-center w-100 ">
                    <div className="d-flex h-100 px-0 align-items-start  justify-content-center">
                      {/* {this.renderAirplaneIcon(flightObj)} */}

                      {/* <div className="d-flex justify-content-around text-uppercase font-gotham px-1 align-items-center font-smaller mobile-light-color col-4 flex-column">
                          <div className="d-flex">
                            {" "}
                            {item.tickets &&
                            item.tickets[index] &&
                            item.tickets[index].pnr
                              ? ` ${this.props.intl.formatMessage({
                                  id: "booking.pnr",
                                })} : ${item.tickets[index].pnr}`
                              : ""}
                          </div>
                          <div className="d-flex">
                            {`${
                              flight.gateway.name
                                ? flight.gateway.name
                                : flight.gateway.code
                            }`}
                          </div>
                        </div> */}

                      {/* {this.props.flag === "reserve" ||
                        this.props.flag === "expired" ? (
                          <div className="d-flex justify-content-start text-uppercase  px-2 align-items-center font-xsmall mobile-light-color">
                            <span className="d-flex">
                              <FormattedMessage id="booking.tickettimelimit" />
                            </span>
                            <span
                              className="d-flex px-1 text-dark "
                              style={{ direction: "ltr" }}
                            >
                              {item.flights.ticketTimeLimit
                                ? `${
                                    direction === "rtl"
                                      ? shamsiTicketLimitTime
                                      : ticketLimitTime
                                  }`
                                : ""}
                            </span>
                          </div>
                        ) : null} */}
                    </div>
                    <div className="d-flex flex-row justify-content-center align-items-center w-100 px-0 pb-2 mb-4">
                      <div className="d-flex flex-column col-3 px-0 justify-content-center font-large ">
                        <span className="  d-flex font-large justify-content-center">
                          {flightObj[0].departureDateTime
                            .split('T')[1]
                            .substring(0, 5)}
                        </span>
                        <span className="text-third text-nowrap text-truncate text-center font-weight-bold font-smaller justify-content-center">
                          {flightObj[0].departureAirport.cityName[name]}
                        </span>
                        <span className="d-flex  text-third font-weight-bold font-smaller justify-content-center">
                          (
                          {
                            flightObj[flightObj.length - 1].departureAirport
                              .cityCode
                          }
                          )
                        </span>

                        {/* <span className="d-flex text-dark font-weight-bold font-smaller justify-content-center">
                          {flightObj[0].departureAirport.code}
                        </span> */}
                      </div>
                      <div className="d-flex flex-column align-items-center col-6 px-0 pt-2">
                        <div className="pb-1 d-flex justify-content-around align-items-center col-11 px-0">
                          {/* <hr
                            className="col-2 p-0"
                            style={{
                              border: "1px solid gray",
                            }}
                          /> */}
                          <div
                            className={`d-flex border py-1 px-2 border-1 border-third text-third default-border-radius-small mobile-rounded text-nowrap h-75 px-0 ${
                              name === 'fa' ? 'font-smaller' : 'font-xsmall'
                            } col-10 justify-content-center align-items-center`}
                          >
                            <FormattedMessage id="booking.duration" />
                            {returnFormatTime(
                              [
                                flight.elapsedTime.slice(0, 2),
                                ':',
                                flight.elapsedTime.slice(2),
                              ].join(''),
                              direction,
                              this.props.intl,
                              true,
                            )}
                          </div>
                          {/* <hr
                            className="col-2 p-0"
                            style={{
                              border: "1px solid gray",
                            }}
                          /> */}
                        </div>

                        <div className="d-flex justify-content-center align-items-center font-smaller font-weight-bold text-secondary pb-2">
                          <span className="d-flex font-weight-bold font-smaller justify-content-start text-third  ">
                            <span className="d-flex font-weight-bold font-smaller text-secondary justify-content-start ">
                              {` ${this.props.intl.formatMessage({
                                id: `booking.${
                                  flight.isCharter ? 'charter' : 'systemic'
                                }`,
                              })}`}
                            </span>
                            <span className="px-1">-</span>
                            {`${
                              flightObj[0].resBookDesigCabinName
                                ? `  ${flightObj[0].resBookDesigCabinName[name]} `
                                : ''
                            } `}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex flex-column col-3 px-0 justify-content-center font-large ">
                        <span className=" d-flex font-large justify-content-center">
                          {flightObj[flightObj.length - 1].arrivalDateTime
                            .split('T')[1]
                            .substring(0, 5)}
                        </span>
                        <span className="text-third text-nowrap text-truncate text-center font-weight-bold font-smaller justify-content-center">
                          {
                            flightObj[flightObj.length - 1].arrivalAirport
                              .cityName[name]
                          }
                        </span>
                        <span className="d-flex  text-third font-weight-bold font-smaller justify-content-center">
                          (
                          {
                            flightObj[flightObj.length - 1].arrivalAirport
                              .cityCode
                          }
                          )
                        </span>
                        {/* <span className="d-flex  font-weight-bold font-smaller text-dark justify-content-center">
                          {flightObj[flightObj.length - 1].arrivalAirport.code}
                        </span> */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div
            className="col-10 px-0  d-flex flex-row py-1  position-absolute justify-content-between align-items-center border border-2 border-muted bg-white default-border-radius-small  mobile-rounded  "
            // style={{
            // 	borderTop: "1px dashed",
            // 	// bottom: "-40%",
            // 	top: "103%",
            // 	left: "50%",
            // 	transform: "translate(-50%, -50%)",
            // }}
            style={{ bottom: '-16px', borderTop: '1px dashed' }}
          >
            {/* <div
								className={`d-flex text-secondary align-items-center ${
									this.props.flag === 'unpaidreservation'
										? ' justify-content-start'
										: ' justify-content-center'
								} px-0 font-small`}
							> */}
            {/* {this.props.flag === 'unpaidreservation' && (
									<div className="px-2">
										<Checkbox
											name={`checkBox-${item._id}`}
											id={item._id}
											inputClassName="mb-0"
											checked={this.state.selectUnpaidFlightList.some(
												(flight) => flight === item._id
											)}
											onChange={(event) => {
												this.selectUnpaidFlight(event);
											}}
										/>
									</div>
								)} */}
            {/* ${totalPassenger} */}
            {/* {` ${this.props.intl.formatMessage({
									id: 'booking.adultprice',
								})}`} */}
            {/* </div> */}
            <div className="d-flex col-2 px-2 flex-row justify-content-start align-items-center font-smaller text-secondary text-nowrap px-1">
              {totalPassenger}
              <span className="pr-1"></span>
              <FormattedMessage id="booking.guest" />
            </div>
            <div className="d-flex col-8 px-0 align-items-center flex-end justify-content-center font-weight-bold text-dark font-normal text-end text-nowrap ">
              {`${numberWithCommas(
                (item.totalPrice / 10).toFixed(0),
              )} ${this.props.intl.formatMessage({
                id: 'booking.toman',
              })}`}
            </div>

            <div className="d-flex col-2 m-0 p-0 justify-content-between align-items-center">
              {item.msps &&
              item.msps.length &&
              item.msps[0].isPoint &&
              parseInt(item.msps[0].value) > 0 ? (
                <div className="align-items-center d-flex justify-content-end p-1">
                  <CoinIcon color="goldenrod" size={14} />
                  {/* show user point */}
                  <span span className="font-smaller px-1">
                    <FormattedMessage
                      id="booking.frompoint"
                      defaultMessage="booking.frompoint"
                    />
                  </span>
                  <span className="font-smaller text-dark px-1">:</span>
                  <span
                    className="font-smaller px-1"
                    style={{ color: 'goldenrod' }}
                  >
                    {item.msps && item.msps.length && item.msps[0].isPoint
                      ? numberWithCommas(
                          parseFloat(item.msps[0].value).toFixed(2),
                        )
                      : 0}
                  </span>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, props) {
  return {
    language: state.language,
    // notification: state.notification
  };
}

export default injectIntl(
  connect(mapStateToProps, {})(withRouter(MobileFlightInfoBooking)),
);
